// hooks/useDocumentTitle.js
import { Helmet } from 'react-helmet';
import { useCustomTheme } from '../../slices/theme/hooks';

export const useDocumentTitle = (pageTitle) => {
    const customTheme = useCustomTheme();

    // Get app name from theme, fallback to 'App' if not available
    const appName = customTheme?.appName || customTheme?.name || 'App';

    const fullTitle = pageTitle ? `${appName} | ${pageTitle}` : appName;

    return { fullTitle, customTheme };
};

// Component approach with favicon support
export const DocumentTitle = ({ title, children }) => {
    const { fullTitle, customTheme } = useDocumentTitle(title);

    // Get favicon from theme - ensure it's a valid string
    const favicon = customTheme?.favicon && typeof customTheme.favicon === 'string' ? customTheme.favicon : null;

    console.log("favicon", favicon);

    return (
        <>
            <Helmet>
                <title>{fullTitle}</title>
                {favicon && (
                    <link rel="icon" type="image/x-icon" href={favicon} />
                )}
                {favicon && (
                    <link rel="shortcut icon" type="image/x-icon" href={favicon} />
                )}
                {favicon && (
                    <link rel="apple-touch-icon" href={favicon} />
                )}
            </Helmet>
            {children}
        </>
    );
};